export default {
  name: 'Accept',
  components: {},
  props: [],
  data() {
    return {};
  },
  computed: {},
  mounted() {
    this.$router.push({ path: `register/${this.$route.query.token}` });
  },
  methods: {}
};
